import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { IAfterGuiAttachedParams } from 'ag-grid-community';
import { HireItem, Product } from '../../models';
import { ConfigService } from '../services/config.service';
import { MomentModule } from 'ngx-moment';
import { NgIf } from '@angular/common';

@Component({
    selector: 'hireitem-off-hire-cell',
    template: `
    <span *ngIf="hireItem?.off_hire; else estimated">
      {{ hireItem?.off_hire | amDateFormat: dateTimeFormat }}
    </span>
    <ng-template #estimated>
      <span class="text-gray-600 italic">
        {{ hireItem.estimated_off_hire | amDateFormat: dateTimeFormat }}
      </span>
    </ng-template>
  `,
    standalone: true,
    imports: [NgIf, MomentModule]
})
export class HireItemOffHireWithEstimateCellComponent
  implements AgRendererComponent
{
  params: any;
  hireItem: { off_hire: string; estimated_off_hire: string };
  name: string;
  dateTimeFormat = ConfigService.dates.shortDateTimeFormat;

  agInit(params: any): void {
    this.params = params;
    this.hireItem = this.params.data;
  }

  refresh(params: any): boolean {
    this.params = params;
    return true;
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {}
}
